import React from "react";
import { observer } from "mobx-react";
import { useRouteMatch } from "react-router-dom";
import { Tooltip } from "antd";
import Logo from "@app/components/client/logo";
import useIsTruncated from "@app/hooks/useIsTruncated";

import "./style/project.scoped.scss";

import report from "@app/state/store/report";
import setup from "@app/state/store/projects/setup";

const Project = observer(() => {
    const setupRoute = useRouteMatch("/r/:id/setup");
    const project =
        report.project ||
        (setupRoute && setup.project?._id === setupRoute.params.id ? setup.project : null);
    const description = setupRoute ? project?.description : null;
    const [nameRef, isNameTruncated] = useIsTruncated(project?.name);
    const [clientRef, isClientTruncated] = useIsTruncated(description);

    if (!project || project.deleted) {
        return;
    }

    return (
        <div className="project">
            <div className="row">
                <div className="logo">
                    <Logo client={project.client} size={30} />
                </div>
                <div className="details">
                    {/* <div className="label">Project</div> */}
                    <Tooltip title={isNameTruncated ? project.name : ""} placement="bottomLeft">
                        <div className="name" ref={nameRef}>
                            {project.name}
                        </div>
                    </Tooltip>
                    <Tooltip title={isClientTruncated ? description : ""} placement="bottomLeft">
                        <div className="client" ref={clientRef}>
                            for {project.client.name}
                            {description && <span className="description"> · {description}</span>}
                        </div>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
});

export default Project;
